export default __webpack_public_path__ + "static/media/location.fb09cfa9.svg";